<template>
    <div class="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-50 to-white text-gray-800">
      <div class="w-full max-w-4xl p-6 mx-auto">
        <AppHeader :currentDateTime="currentDateTime" />
  
        <!-- Main Content -->
        <main class="flex flex-col md:flex-row gap-12 animate-fade-in-up" style="animation-delay: 0.3s">
          <AppSidebar />
          <section class="md:w-3/4 md:pl-8 font-inter text-lg leading-relaxed">
            <p class="mb-6">
              Preko 800 pasioniranih programera, startapera, IT biznismena i onih koji tehnologiju doživljavaju kao istinski zanimljivu, od 28. do 30. septembra posetilo je VoxxedDays Belgrade konferenciju, najveći i najinspirativniji IT događaj u regionu.
            </p>
            <p class="mb-6">
              Na oduševljenje okupljenih, preko 90 priznatих IT stručnjaka iz renomiranих svetsких kompanija poput Amazona, Google-а, Pixara, JetBrains­a, Atlassian­a, RedHat­a, Pivotal­a, Yammer­a и IBM­a održalo je predavanja о brojnim ‘vrućim’ IT и biznis trendovima u okviru čak četiri paralelne trake!
            </p>
            <p class="mb-6">
              Voxxed dane u Beogradu otvorio je čуveni Scott Amyx — jedan od 10 najboljих svetsких predavača у 2015. godini i dobitnik Cloud&DevOps награде за 2016. У okviru niza predavanja i panela koje je održao objasnio je zašto smatra да će IoT tehnologije imati ключную уlogu в трансформации sveta kakav znamo danas. O neverovatним načinима kojima se подstiče креативность в Pixaru govorio je Antoni Kristov, globalni umetnički direktor ove компанije, poznat и по crtanом фильму WALL•E, dok je Karolina Lewandowska predstavila ‘flat’ organаzacionu kulturu njene компанije Google, kojом se povećava инновативность и povezanost.
            </p>
            <p class="mb-6">
              Prisutni su još slušali i о nesvakidašnjим pristupima virtualnoj реальности, chatbotovima, nepravednoj запоставленности hardverskih у odnosu на softverske startape, ‘clean’ kodu, brojnим programskim jezicima, programirali и učili нове veštine u okviru radionica. Радонице из роботике bile su организоване и за najmlađe posetioce, koji su параллельно могли да uživaju у Lego svetu robotića.
            </p>
            <p class="mb-6">
              Po rečima učesnika и predavača, kvalitetu izabranих tema и организации, Voxxed Days Belgrade конференция Srbiju je позиционирала на mapu najvećih технолошких događaja у Evropi. Heapspace zajednica, организатор Voxxed Days конференции, planira да ovaj trend nastavi pa su pripreme за treći Voxxed Days Belgrade već запočеле.
            </p>
            <p class="mb-6">
              <a href="http://www.ogledalo.rs/danas-je-poslednji-dan-druge-voxxeddays-belgrade-konferencije/" class="text-emerald-600 hover:text-emerald-700 transition-colors duration-300">
                Прочитать больше
              </a>
            </p>
          </section>
        </main>
        
        <AppFooter />
      </div>
    </div>
  </template>
  
  <script>
  import AppHeader from './AppHeader.vue'
  import AppFooter from './AppFooter.vue'
  import AppSidebar from './AppSidebar.vue'
  
  import '@/assets/styles/main.css'; // Импортируйте ваш CSS файл
  
  export default {
    name: "ArticlePage",
    components: {
      AppHeader,
      AppFooter,
      AppSidebar
    },
    data() {
      return {
        currentDateTime: '',
        updateInterval: null
      }
    },
    mounted() {
      this.updateDateTime()
      this.updateInterval = setInterval(this.updateDateTime, 1000)
    },
    beforeUnmount() {
      if (this.updateInterval) {
        clearInterval(this.updateInterval)
      }
    },
    methods: {
      updateDateTime() {
        const now = new Date()
        this.currentDateTime = now.toISOString().replace('T', ' ').substr(0, 19)
      }
    }
  };
  </script>